import {
  dashboardUrl,
  submitPaypal,
  submitStripe,
} from './api'
import {
  TOGGLE_PAYMENT_LOADER,
} from '../store/types'

export default {
  computed: {
    paymentGateway: function () {
      return this.$store.state.user['address']['country'].toLowerCase() === 'br'
        ? 'stripe'
        : 'paypal'
    },
    paymentCurrency: function () {
      return this.$store.state.user["address"]["country"].toLowerCase() === "br"
        ? "BRL"
        : "USD";
    },
  },
  methods: {
    makePayment: function (
      amount,
      finality,
      paymentMethod = "credit_card",
      installments = "1"
    ) {
      console.log("makePayment method invoked");
      return new Promise((resolve, reject) => {
        if (this.paymentGateway === "stripe") {
          this.payStripe(amount, finality, resolve);
        } else {
          this.payPaypal(amount, finality, resolve);
        }
      });
    },
    payPaypal: async function (amount, finality, resolve) {
      this.$store.commit(TOGGLE_PAYMENT_LOADER, true)
      if (finality['finality'] === 'membership') {
        await submitPaypal(finality['post_id'])
      }
      let form = document.createElement('form')
      form.style.display = 'none'
      document.body.appendChild(form)
      form.method = 'post'
      form.action = process.env.NODE_ENV === 'production'
        ? 'https://www.paypal.com/cgi-bin/webscr'
        : 'https://www.sandbox.paypal.com/cgi-bin/webscr'
      // noinspection JSAnnotator
      const formData = {
        business: process.env.NODE_ENV === 'production'
          ? 'financeiro@inspirationphotographers.com'
          : 'contato@hf.works',
        return: dashboardUrl,
        charset: 'utf-8',
        currency_code: 'USD',
        no_shipping: '1',
        no_note: '1',
        item_name: 'Inspiration Photographers',
        notify_url: this.$store.state.user['postback_url'],
        custom: JSON.stringify(finality)
      }
      if (finality['type'] === 'subscription') {
        formData.cmd = '_xclick-subscriptions'
        formData.a3 = (amount / 100).toFixed(2)
        formData.p3 = '30'
        formData.t3 = 'D'
        formData.src = '1'
      } else {
        formData.cmd = '_xclick'
        formData.amount = (amount / 100).toFixed(2)
      }
      for (let name in formData) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = formData[name]
        form.appendChild(input)
      }
      this.$store.commit(TOGGLE_PAYMENT_LOADER, false)
      form.submit()
    },
    payStripe: async function (amount, finality, resolve) {
      await submitStripe(this.paymentCurrency, amount, finality);
    },
  }
}
